import { pendingTask, begin, end } from "react-redux-spinner";
import { put } from "redux-saga/effects";

import UserFeedback from "../user.feedback";
import { IResetPassword, resetPasswordResponse } from "../user.actions";
import UserService from "../user.service";
import { HttpError, HttpsStatusCode } from "@common";

export function* resetPasswordSaga(action: IResetPassword) {
  if (action.payload instanceof Error) {
    return;
  }

  const { username } = action.payload;
  if (!username) {
    return yield put(
      resetPasswordResponse(
        new Error(UserFeedback.USERNAME_MISSING),
        UserFeedback.USERNAME_MISSING
      )
    );
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });
  try {
    const service = new UserService();
    const response = yield service.resetPassword(username);
    yield put(resetPasswordResponse(response, UserFeedback.PASSWORD_REST));
  } catch (error) {
    if (error instanceof HttpError) {
      if (error.status === HttpsStatusCode.NotFound) {
        return yield put(
          resetPasswordResponse(
            new Error(UserFeedback.PASSWORD_RESET_FAILED),
            UserFeedback.PASSWORD_RESET_FAILED
          )
        );
      }
    }

    yield put(resetPasswordResponse(error, UserFeedback.PASSWORD_RESET_FAILED));
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}
